// extracted by mini-css-extract-plugin
module.exports = {"root":"QuantityPopup_root__cXdhX","count":"QuantityPopup_count__s_wi8"};